import { NextPage, GetStaticProps, GetStaticPaths } from 'next';
import Webtoons from '@/components/screens/webtoons/Webtoons';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';

interface IGenresPageProps {
  books: IGenreBooksPage;
}

const GenresPageDynamic: NextPage<IGenresPageProps> = ({ books }) => {
  return <Webtoons books={books} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}genres/aldebaran/books/vebtun?sort_by_popular=true&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default GenresPageDynamic;
